export enum CalenderReportType {
    
    BuyAndSaleCount=0, 
    
    BuyAndSalePrice=1, 
    
    CollectiveSale=2, 
    
    SeparateSale=3, 
}


